import { extend, override } from 'flarum/common/extend';
import LogInModal from './components/LogInModal';
import SignUpModal from './components/SignUpModal';
import SettingsPage from './components/SettingsPage';
import ChangeEmailModal from './components/ChangeEmailModal';
import AvatarEditor from './components/AvatarEditor';
// import WelcomeHero from './components/WelcomeHero';

app.initializers.add('vendor/pentaspec', () => {
  //
});
